module.exports = __webpack_public_path__ + "static/media/tums.6b022643.png";